export const assembleAddressStringForDestination = ({
    street,
    city,
    postalCode,
}) => {
    const postalCodeAppend = postalCode ? `, ${postalCode}` : '';
    const cityString = city ? postalCode ? ` ${city}` : `, ${city}` : '';
    return `${street || ''}${postalCodeAppend}${cityString}`;
};
